<template>
  <div class="contact">
    <div class="container">
      <h1>Contact page</h1>
    </div>
  </div>
</template>
